import { captureEvent } from "@Light/app/analytics";
import { BottomSheet } from "@Light/components/page/BottomSheet";
import { Button } from "@Light/components/page/Button";
import { AlertCircle } from "@untitledui/icons";
import { useEffect } from "react";
import { useSupportBottomSheet } from "@Light/components/page/SupportBottomSheet";

export type RateUnavailableSheetProps = {
  open: boolean;
  onReload: () => void;
};

export const RateUnavailableSheet = ({
  open,
  onReload,
}: RateUnavailableSheetProps) => {
  const openSupport = useSupportBottomSheet();

  useEffect(() => {
    if (open) {
      captureEvent("rate_unavailable_shown");
    }
  }, [open]);

  return (
    <BottomSheet open={open} onClose={() => {}} hideCloseButton>
      <div
        data-testid="rate-unavailable"
        className="flex flex-col gap-2xl py-3xl px-xl expanded:px-3xl expanded:min-h-full"
      >
        <div className="flex flex-1 flex-col items-center justify-center gap-xl">
          <AlertCircle className="size-7 text-quaternary stroke-[1.71px]" />
          <div className="w-full text-md font-bold text-primary">
            Sorry, we were unable to get your rates at this time. Please try
            again.
          </div>
        </div>
        <div className="flex flex-col gap-md">
          <Button
            className="w-full"
            onClick={() => {
              captureEvent("rate_unavailable_reload_clicked");
              onReload();
            }}
            data-testid="reload-plan-button"
          >
            Reload plan
          </Button>
          <Button
            className="w-full"
            buttonType="outline"
            onClick={() => {
              captureEvent("support_button_clicked", {
                variant: "rate_unavailable",
              });
              openSupport();
            }}
            data-testid="reach-out-button"
          >
            Reach out to us
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};
